<template>
  <v-main class="mainProductSearch">
    <div class="max_width_container">
      <v-dialog persistent v-model="cepDialog" max-width="450px">
        <Cep @reaload="reaload"></Cep>
      </v-dialog>
      <breadcrumbs class="my-2" :items="items"></breadcrumbs>

      <v-row cols="12" class="d-flex">
        <v-col class="filtes-content" cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
          <filters
              @product="searchForProductsByName"
              @selected-sizes="setSelectedSizes"
              @selected-subcategories="setSubcategories"
              @filter-by="setFilterBy"
              title="Produtos"
          >
          </filters>
        </v-col>

        <v-col cols="12" xs="12" sm="12" md="12" lg="10" xl="10">
          <v-row cols="12" v-if="loadingResale || (resale && resale.id)" class="mb-5">
            <v-col class="px-5" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
              <!-- Skeleton do cabeçalho da loja -->
              <template v-if="loadingResale">
                <v-skeleton-loader
                    type="image"
                    :height="isMobile ? 160 : 300"
                    class="showcase-skeleton mb-3"
                ></v-skeleton-loader>
                <v-skeleton-loader type="article"></v-skeleton-loader>
              </template>

              <template v-else>
                <v-img
                    v-if="resale && (isMobile ? resale.imageMobileShowcase : resale.imageDesktopShowcase)"
                    :src="isMobile ? resale.imageMobileShowcase : resale.imageDesktopShowcase"
                    :height="isMobile ? 160 : 320"
                    cover
                    class="showcase-banner"
                    alt="Vitrine da loja"
                ></v-img>

                <v-card flat class="resale-card mt-4 pa-5">
                  <p class="nameFantasy mb-2" v-if="resale && resale.nameShowcase">
                    {{ resale.nameShowcase }}
                  </p>

                  <div class="d-flex align-center flex-wrap mb-3">
                    <v-chip
                        v-if="resale && resale.reviews && resale.reviews.length > 0"
                        small
                        label
                        color="#FFF6E5"
                        text-color="#B8860B"
                        class="mr-2 mb-1"
                        style="cursor: pointer"
                        @click="goToReviews($event)"
                    >
                      <v-icon left size="16" color="#E2B100">mdi-star</v-icon>
                      {{ note.toFixed(1) }} ({{ resale.reviews.length }})
                    </v-chip>

                    <v-chip
                        v-if="resale && resale.distance"
                        small
                        label
                        color="#FDECEC"
                        text-color="#BC0000"
                        class="mb-1"
                    >
                      <v-icon left size="16" color="#BC0000">mdi-map-marker</v-icon>
                      {{ resale.distance.toFixed(2) }} KM de Você
                    </v-chip>
                  </div>

                  <p class="resale-info mb-2" v-if="resale && resale.descriptionShowcase">
                    {{ resale.descriptionShowcase }}
                  </p>
                  <p class="resale-info d-flex align-start" v-if="resale && resale.addressShowcase">
                    <v-icon size="18" color="#6D7989" class="mr-1">mdi-map-marker-outline</v-icon>
                    {{ resale.addressShowcase }}
                  </p>
                </v-card>
              </template>
            </v-col>
          </v-row>


          <product-pagination
              :page="page"
              :totalPages="totalPages"
              :totalItems="totalItems"
              :quantityProducts="products.length"
              @selected-page="setPage"
              @filter-by="setFilterBy"
          >
          </product-pagination>


          <div v-if="loadingProducts" class="list-product-content">
            <v-skeleton-loader
                v-for="n in 8"
                :key="n"
                type="image, article"
                class="ma-1"
            ></v-skeleton-loader>
          </div>

          <div v-else-if="products && products.length > 0" class="list-product-content">
            <div v-for="item in products" class="ma-1" :key="item.productId">
              <ImageCard
                  :key="item.productId"
                  :item="item"
                  :env_url="env_url"
              />
            </div>
          </div>

          <div v-else class="my-3">
            <h4>Nenhum resultado para: {{ this.resale.nameFantasy }}</h4>
          </div>
        </v-col>
      </v-row>

      <v-row v-if="resale && resale.reviews && resale.reviews.length > 0" id="ratings" cols="12" class="d-flex mx-2">
        <v-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <div class="note-header">
            <span class="note-header-text">Nota</span>
          </div>
          <div class="d-flex justify-center mt-1 align-center">
            <div>{{ note.toFixed(1) }}</div>
            <div>
              <v-rating
                  v-model="note"
                  background-color="yellow"
                  color="yellow"
                  size="20"
                  readonly
                  half-increments
                  empty-icon="mdi-star-outline"
                  full-icon="mdi-star"
                  half-icon="mdi-star-half-full"
              ></v-rating>
            </div>
          </div>
          <div class="mt-1">
            <p class="text-center text-avaliacao">{{ resale.reviews.length }}
              {{ resale.reviews.length > 1 ? 'avaliações' : 'avaliação' }}</p>
          </div>
        </v-col>

        <v-col class="filtes-content" cols="12" xs="12" sm="12" md="12" lg="9" xl="9">

          <div class="note-header">
            <span class="note-header-text">Comentários</span>
          </div>
          <div style="max-height: 500px; overflow-y: auto">
            <div class="mt-3" v-for="(review, i) in resale.reviews" :key="`${review.id}+${i}`">
              <div class="d-flex align-start ">
                <div class=" mr-2">
                  <v-img
                      class="review-user-image"
                      v-if="review.user.image"
                      :src="review.user.image"
                      cover
                  >
                  </v-img>
                  <v-icon size="50" v-else> mdi-account-circle</v-icon>
                </div>
                <div>
                  <div class="review-date">
                <span>
                {{ formatDate(review.created_at) }}
              </span>
                  </div>
                  <div>
                    <v-rating
                        v-model="review.note"
                        background-color="yellow"
                        color="yellow"
                        size="16"
                        readonly
                        half-increments
                        empty-icon="mdi-star-outline"
                        full-icon="mdi-star"
                        half-icon="mdi-star-half-full"
                    ></v-rating>
                  </div>

                  <div class="review-user-name">
                <span>
                {{ review.user.name }}
              </span>
                  </div>
                  <div class="review-evaluation mt-1">
                <span>
                {{ review.evaluation }}
              </span>
                  </div>
                </div>
              </div>
              <div v-if="i < resale.reviews.length - 1" class="divider mt-2"></div>
            </div>
          </div>
        </v-col>

      </v-row>
    </div>
  </v-main>
</template>

<script>
import ApiService from "../../../services/ApiService";
import ImageCard from "../components/ImageCard.vue";
import Breadcrumbs from "../components/Breadcrumbs.vue";
import Filters from "../components/Filters.vue";
import ProductPagination from "../components/ProductPagination.vue";
import Vue from "vue";
import FormatParamsUrl from "../../../Utils/FormatParamsUrl";
import FormatText from "../../../Utils/FormatText";
import Cep from "../components/Cep.vue";
import product from "../Product/Product.vue";
import Utils from "../../../Utils/FormatDate";

export default {
  name: 'Showcase',
  components: {
    Cep,
    ImageCard,
    Breadcrumbs,
    Filters,
    ProductPagination,
  },
  metaInfo() {
    return {
      meta: this.meta,
      title: this.title,
    }
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, {passive: true});
    }
  },

  async mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, {passive: true});
    await this.geteResaleByUrl();
    this.title = FormatText.capitalizeFirst(this.resale && this.resale.nameFantasy ? this.resale.nameFantasy : '')
    this.meta = [
      {
        vmid: 'description',
        name: 'description',
        content: this.resale.nameFantasy,
      }
    ]
    await this.advancedSearch();
    this.$root.$on("advancedSearch", () => {
      this.advancedSearch();
    });
    this.items = [
      {
        text: "Página Inicial",
        disabled: true,
        href: "/home",
      },
      {
        text: "Vitrine",
        disabled: true,
        href: "",
      },
      {
        text: this.title,
        disabled: false,
        href: "",
      },
    ]
    this.cepDialog = this.checkUserFilledZipCode()
  },

  data: () => ({
    meta: [],
    note: 0,
    title: "",
    resale: Object,
    cepDialog: false,
    seller: null,
    cep: null,
    env_url: "",
    loading: false,
    loadingProducts: true,
    loadingResale: true,
    isEmpty: false,
    componentKey: 1,
    fecharFiltro: false,
    attributeName: "",
    categoriaName: "",
    close: [],
    isMobile: false,
    products: [],
    productCategories: [],
    apiService: new ApiService(),
    page: 1,
    totalPages: 1,
    totalItems: 0,
    pageSize: 20,
    items: [
      {
        text: "Página Inicial",
        disabled: true,
        href: "/home",
      },
      {
        text: "Vitrine",
        disabled: true,
        href: ""
      }
    ],
    filter: {
      resaleId: null,
      product: "",
      page: 1,
      pageSize: 15,
      selectedSizes: [],
      Subcategories: [],
      orderByPrice: 0,
    },
    categories: [],
  }),


  computed: {
    product() {
      return product
    }
  },
  async created() {
    this.env_url = process.env.VUE_APP_BASE_URL;
  },

  methods: {
    goToReviews(event) {
      event.preventDefault();
      const element = document.querySelector("#ratings");
      const offset = 150;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
      const top = elementRect - bodyRect + scrollTop - offset;
      window.scrollTo({
        top,
        behavior: "smooth",
      });
    },

    calculateAverageRatings() {
      if (this.resale.reviews && this.resale.reviews.length) {
        this.note =
            this.resale.reviews.reduce(
                (accumulator, currentValue) =>
                    Number(accumulator) + Number(currentValue.note),
                0
            ) / this.resale.reviews.length;
      }
    },

    reaload() {
      this.cepDialog = false;
      window.location.reload();
    },

    checkUserFilledZipCode() {
      this.cepDialog = false
      let address = localStorage.getItem("address_cep");
      if (!address) {
        return true;
      }
      address = JSON.parse(address)
      const {cep, latitude, longitude} = address
      return !cep || !latitude || !longitude;
    },

    setPage(page) {
      this.page = page
      this.filter.page = this.page;
      this.updatePageView();
    },

    async geteResaleByUrl() {
      try {
        const {seller} = this.$route.params
        let address = localStorage.getItem("address_cep");
        address = JSON.parse(address);
        const {cep, latitude, longitude} = address
        const params = {
          cep,
          latitude,
          longitude,
          UrlStore: seller
        }
        this.resale = await this.apiService.get(`resale/url-store`, true, false, params);
        this.calculateAverageRatings()
      } catch (e) {

      } finally {
        this.loadingResale = false;
      }
    },

    setFilterBy(filterBy) {
      this.filter.orderByPrice = filterBy;
      this.filter.page = this.page;
      this.updatePageView();
    },

    async searchForProductsByName(product) {
      this.filter.product = product
      this.filter.page = 1;
      this.page = 1
      await this.updatePageView();
    },

    async setSelectedSizes(selectedSizes) {
      this.filter.selectedSizes = selectedSizes
      this.filter.page = 1;
      this.page = 1
      await this.updatePageView();
    },

    async setSubcategories(selectedSubcategories) {
      this.filter.Subcategories = selectedSubcategories
      this.filter.page = 1;
      this.page = 1
      await this.updatePageView();
    },

    async advancedSearch() {
      this.filter.product = this.$route.query.produto ? this.$route.query.produto : "";
      await this.updatePageView();
      if (this.filter.product) {
        await this.saveSearch();
      }
    },

    onResize() {
      this.isMobile = window.innerWidth < 960;
    },

    async updatePageView() {
      this.loading = true;
      this.loadingProducts = true;
      try {
        this.filter.pageSize = this.pageSize;
        this.filter.page = this.page;
        this.filter.page = this.page;
        this.filter.resaleId = this.resale.id;
        await this.apiService
            .post(`product/listActiveB2C`, this.filter, null, true, false)
            .then((response) => {
              this.totalPages = response.pager.totalPages;
              this.products = response.products;
              this.totalItems = response.pager.totalItems;
              this.isEmpty = this.products.length === 0;
            });
        this.loading = false;
      } finally {
        this.loadingProducts = false;
      }
    },

    async saveSearch() {
      await this.apiService.post("search", {searchedText: this.filter.product}, null, true, false);
    },

    async goTo(item) {
      const param = FormatParamsUrl.format(item.productName);
      await this.$router.push({
        path: `/produtos/${param}`,
        params: item,
        query: {vendedor: this.resale.urlStoreResale}
      });
    },
    formatDate(date) {
      return Utils.moment(date);
    },
  },
  watch: {
    pageSize() {
      this.filter.pageSize = this.pageSize;
      this.updatePageView();
    },
  },
};
</script>

<style scoped>
.divider{
  width: 100%;
  height: 1px;
  background: #E0E0E0;
}

.showcase-banner {
  width: 100%;
  border-radius: 12px;
}

.resale-card {
  border-radius: 12px !important;
  box-shadow: 0 4px 16px rgba(5, 29, 61, 0.08) !important;
}

.resale-info {
  font-weight: 500;
  font-size: 16px;
  line-height: 1.5;
  color: #4F4F4F;
  margin: 0;
}
.review-date {
  font-weight: 400;
  font-size: 15px;

  color: #828796;
}

.review-user-name {
  font-weight: 700;
  font-size: 15px;
  color: #3F4247;
}

.review-evaluation {
  font-weight: 400;
  font-size: 15px;
  color: #3F4247;
}

.review-user-image {
  height: 50px !important;
  width: 50px !important;
  border-radius: 50% !important;
}

.text-avaliacao {
  font-weight: 700;
  line-height: 100%;
  letter-spacing: 0.15px;

  color: #000000
}

.note-header {
  background: #F5F5F5;
  padding: 10px 14px;
  border-radius: 8px;
  border-left: 4px solid #BC0000;
}

.note-header-text {
  font-weight: 700;
  line-height: 100%;
  letter-spacing: 0.15px;
  color: #2D3038;
}

.nameFantasy {
  font-weight: 700;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: 0.15px;
  color: #000000;
}

.km {
  font-weight: 300;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: 0.15px;
  color: #000000;
}

.max_width_container {
  width: 80% !important;
  margin: 0 10% 0 10%;
}

.list-product-content {
  display: grid !important;
  grid-template-columns: repeat(auto-fill, minmax(200px, auto));
}

@media (orientation: landscape) {
  .landscape {
    display: flex;
  }
}

@media (max-width: 1264px) {
  .max_width_container {
    width: 100% !important;
    margin: 0;
  }
}

@media (max-width: 600px) {
  .list-product-content {
    grid-template-columns: 1fr;
    justify-items: center;
  }

  .nameFantasy {
    font-size: 20px;
  }

  .resale-info,
  .km {
    font-size: 14px;
  }
}
.resale{

}
.mainProductSearch {

}

@media (min-width: 600px) {
  .mainProductSearch {
    display: flex !important;
    max-width: unset !important;
    padding-top: 0px !important;
  }
}
@media (min-width: 800px) {

}
</style>
